// ========= START: bp-tango-dev/src/components/TangoWelcomeScreen.js (ADDED HUB LINK) =========
import React from 'react';

function TangoWelcomeScreen({ onStart }) {
  const welcomeScreenStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/backgrounds/welcome-bg.jpg)`
  };

  return (
    <div className="tango-welcome-screen" style={welcomeScreenStyle}>
      {/* NEW: Return to Hub Button */}
      <a href="http://bplabo.jp" className="labo-hub-return-btn">
        ↩️ LABO Hub
      </a>

      <img
        src={`${process.env.PUBLIC_URL}/assets/backgrounds/action_lines.png`}
        alt=""
        className="action-lines-overlay"
      />
      <div className="tango-welcome-content">
        <img
          src={`${process.env.PUBLIC_URL}/assets/logo/bp-tango-logo.png`}
          alt="BP Tango Logo"
          className="tango-welcome-logo"
        />
        <button className="welcome-start-button" onClick={onStart}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo/start_tango.png`}
            alt="Start Button"
          />
        </button>
      </div>
    </div>
  );
}

export default TangoWelcomeScreen;
// ========= END: bp-tango-dev/src/components/TangoWelcomeScreen.js (ADDED HUB LINK) =========